import * as React from 'react'

const Windows: React.FC = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5 6.34339L10.043 5.44842V11.7315L3.5 11.7863V6.34339ZM10.043 12.4621V18.7635L3.5 17.8685V12.4256L10.043 12.4621ZM10.831 5.33883L19.5 4.07855V11.6585L10.831 11.7315V5.33883ZM19.5 12.5352V20.0786L10.831 18.8548L10.8127 12.5169L19.5 12.5352Z" />
  </svg>
)

export default Windows
